import React from 'react';
import PropTypes from 'prop-types';

import HeaderScene from './HeaderScene';
import Nav from './Nav';
import HeaderWrapperStyled from './styles/HeaderStyled';

const Header = ({ gradient }) => {
  return (
    <HeaderWrapperStyled gradient={gradient}>
      <Nav />
      {!gradient && <HeaderScene />}
    </HeaderWrapperStyled>
  );
};
Header.propTypes = {
  gradient: PropTypes.bool,
};

Header.defaultProps = {
  gradient: false,
};

export default Header;
